import { PlusIcon } from '@heroicons/react/20/solid';
import { ANCHORS } from 'constants/anchors';
import styled from 'styled-components';

interface IScenarioGeneratorCardProps {
  title?: string;
  onButtonClick: () => void;
  buttonText?: string;
}

const DEFAULT_TITLE = "Create your Own Scenario";
const DEFAULT_BUTTON_TEXT = "Create scenario";

const ScenarioGeneratorCard: React.FC<IScenarioGeneratorCardProps> = (props) => {
  const {
    title = DEFAULT_TITLE,
    onButtonClick,
    buttonText = DEFAULT_BUTTON_TEXT
  } = props;

  return (
    <CardContainer id={ANCHORS.GENERATOR_SCENARIO}>
      <Title>{title}</Title>
      <OrangeButton onClick={onButtonClick}>
        <PlusIcon className="h-6 w-6" /> {buttonText}
      </OrangeButton>
    </CardContainer>
  );
};

export default ScenarioGeneratorCard;

const CardContainer = styled.div`
  margin: 24px 0;
  display: flex;
  flex-direction: column;
  color: white;
  align-items: center;
  justify-content: center;
  gap: 32px;
  padding: 46px 32px;
  background-color: rgba(70, 55, 50, 1);
  border-radius: 12px;
  
  @media (max-width: 720px) {
    padding: 46px 32px;
  }
`;

const Title = styled.span`
  color: #FFF;
  text-align: center;
  font-family: Raleway;
  font-size: 40px;
  font-weight: 700;
  line-height: 42px; 

  @media (max-width: 720px) {
    font-size: 20px;
    line-height: 22px;
  }
`;

const OrangeButton = styled.button`
  background-color: rgba(255, 126, 85, 1);
  width: fit-content;
  padding: 12px 24px;
  border-radius: 100px;
  font-family: Nunito Sans;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  box-shadow: 0px 12px 40px 0px rgba(255, 126, 85, 0.12);
  display: flex;
  gap: 8px;
  align-items: center;
`; 